export const swapTypeMap = {
    'CHAIN': 1,
    'LOOP': 2,
    '': 0
}